import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import { FeatureFlags } from '@/helpers/featureFlags'

/**
 * Reads the `credit-card-convenience-fee-percent` LaunchDarkly flag and
 * returns the multiplier callers can pass to
 * `calculateCreditCardConvenienceFee` / `computeConvenienceFees`. The flag
 * holds a percent (e.g. `3` for 3%); this hook handles the conversion to a
 * multiplier (`× 0.01`) so call sites don't repeat it.
 */
export const useCreditCardConvenienceFeeMultiplier = (): number => {
  const percent = useFlag(FeatureFlags.CREDIT_CARD_CONVENIENCE_FEE_PERCENT)
  return percent * 0.01
}
